export default __webpack_public_path__ + "static/media/keto_appetite@3x.cfb66fc4.jpg";